import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import config from '../config'

firebase.initializeApp(config.firebase)
firebase.auth().languageCode = 'es_419'

export const db = firebase.firestore()
export const storage = firebase.storage()
export const storageRef = storage.ref()
export const functions = firebase.functions()
window.functions = functions
export { firebase }
